// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607270307/js/" + chunkId + "." + {"44":"bef7d1b5","225":"4a87ea31","481":"8a8ee7e1","486":"f1b67896","770":"5732f4e9"}[chunkId] + ".0.5732508577740679.chunk.js";
};